import React from 'react';
import classNames from 'classnames';

import { IconHeart, NamedLink } from '../../../../components';

import css from './TopbarWishlistLink.module.css';

/**
 * Wishlist shortcut, sitting immediately left of the account menu on both topbars.
 *
 * WishlistsPage is already `auth: true, authPage: 'LoginPage'` in the route config,
 * so signed-out visitors are redirected to log in and returned here afterwards —
 * no auth handling is needed at this level.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {Object} props.intl
 * @returns {JSX.Element} wishlist link
 */
const TopbarWishlistLink = props => {
  const { className, rootClassName, intl } = props;
  const label = intl.formatMessage({ id: 'TopbarDesktop.wishlistsLink' });

  return (
    <NamedLink
      name="WishlistsPage"
      className={classNames(rootClassName || css.root, className)}
      title={label}
      aria-label={label}
    >
      <IconHeart rootClassName={css.icon} />
    </NamedLink>
  );
};

export default TopbarWishlistLink;
